// extracted by mini-css-extract-plugin
export default {"Main":"App_Main__l5FHW","PageContainer":"App_PageContainer__BhEgO"};